var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MaterialMain',{attrs:{"type":_vm.data.uiName},on:{"select":_vm.selectHandler}})}
var staticRenderFns = []

export { render, staticRenderFns }